<div class="desktop-restricted-overlay d-flex justify-center items-center" *ngIf="showComponent">
  <div class="desktop-restricted-container d-flex flex-col">
    <div class="desktop-restricted-header d-flex flex-col flex-gap-1">
        <div class="desktop-restricted-header-icon"></div>
        <div class="desktop-restricted-header-title d-flex flex-col flex-gap-2">
            <h2 class="Roboto">Desktop View Recommended</h2>
            <span class="font-14 Roboto font-weight-normal">For the best experience, we recommend using a desktop or laptop.</span>
        </div>
    </div>
    <div class="desktop-restricted-footer d-flex flex-col flex-gap-4">
        <button class="continue-button font-14 text-white Roboto rounded" (click)="continueOnMobile()">Continue anyway</button>
        <button class="close-button font-14 Roboto rounded" (click)="closePopup()">Back to Home</button>
    </div>
  </div>
</div>

<ng-content></ng-content>
